import React, { useState } from 'react'
import { Button } from '../../ui/button'
import { COMMON_CONSTANTS, KYC_CONSTANTS, PAYMENT_CONSTANTS } from '../../sharedfiles/Constants'
import VButtonGroup from '../Common/Buttons/VButtonGroup'
import ConfirmDialog from '../Common/Dialog/ConfirmDialog'

const KycCommentBox = (props) => {
    const [comments, setComments] = useState("")
    const [error, setError] = useState("")
    const [confirm, setConfirm] = useState(false)

    const { close, finish, cancelBtn } = props

    const commentsHandler = (e) => {
        const { value } = e.target
        setComments(value)
        setError(value ? '' : 'Please mention your comments')
    }

    function valdiate() {
        if (comments.length < 4) {
            setError('Please enter valid Comments')
            return false
        }
        setError('')
        return true
    }

    const actionHandler = () => {
        const isValid = valdiate()
        if (isValid) {
            setConfirm(true)
        }
    }

    const verifyHandler = () => {
        finish(comments)
        setConfirm(false)
        close()
    }
    const rejectHandler = () => {
        setConfirm(false)
        close()
    }

    return (
        <React.Fragment>
            <ConfirmDialog
                title={'Are you sure you want to continue?'}
                open={confirm}
                close={() => setConfirm(false)}
                verify={verifyHandler}
                cancel={rejectHandler}
                width={"sm"}
            />
            <div className="flex flex-col items-center justify-center py-8">
                <div className="text-muted-foreground text-base">
                    <div className="overflow-x-auto">
                        <table>
                            <thead>
                                <tr>
                                    <th>{PAYMENT_CONSTANTS.th_comments}</th>
                                    <th>{KYC_CONSTANTS.header_action}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <input
                                            type="text"
                                            name="notes"
                                            value={comments}
                                            placeholder="Mention your comments here"
                                            onChange={(e) => commentsHandler(e)}
                                        />
                                        {error ? (
                                            <div className="text-sm text-red-500 mt-1">{error}</div>
                                        ) : null}
                                    </td>
                                    {cancelBtn ?
                                        <td>
                                            <Button
                                                onClick={() => actionHandler()}
                                                variant="secondary"
                                                size="sm"
                                            >
                                                {COMMON_CONSTANTS.cancel}
                                            </Button>
                                        </td>
                                        : <td>
                                            <VButtonGroup
                                                buttons={["Decline"]}
                                                decline={actionHandler}
                                                size="sm"
                                            />
                                        </td>}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default KycCommentBox